export default {
  button: {
    submit: '确 定',
    cancel: '取 消',
    reset: '重 置',
    previous: '上一张',
    next: '下一张',
    lastStep: '上一步',
  },
  title: '图片裁剪',
  videoTitle: '视频剪辑',
  cropTimer: '截取时间',
  imageZoom: '图片缩放',
  imageSize: '图片尺寸',
  xlzTitle: '序列帧裁剪',
  closeTip: '上传中不允许关闭弹窗',
  submit: '完成',
}
